import { render, staticRenderFns } from "./AgentTermsOfService.vue?vue&type=template&id=50464a34"
import script from "./AgentTermsOfService.vue?vue&type=script&lang=js"
export * from "./AgentTermsOfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports